<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data" placeholder="请选择"
           :multiple='multiple' collapse-tags  @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    // import { findTypeList } from "@/services/deviceOrder";
     import {getCascade} from '@/services/product'

    export default {
        name: 'MultipleType',
        props: {
            value: {},
            // type:"",
             brandId:{
                type: Number,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {data: [], deviceType: []}
        },
        watch: {
            value:{
                immediate: true,
                handler(value) {
                         this.data=value; 
                   
                }
            },
             brandId:{
                immediate:true,
                handler(value){
                    if(value){
                         this.loadData(value);
                    }
                   
                }
            },
           
        },
        mounted() {
            // this.loadData();
        },
        methods: {
           
            handleChange(value) {
                

                this.data=value;
                let arr= this.deviceType.filter((item)=>{
                    return value.includes(item.value)
                })
                
                    
                let name=[]
                arr.forEach((item)=>{
                         name.push(item.name)
                })
                this.$emit("input",value);
                this.$emit("change", {name:name})
            },
            async loadData(brandId) {
               this.deviceType =[]
            //    this.data = [];
               const response = await getCascade( { brandId });
              
                if (response&&response.code==0) {
                    this.deviceType = response.data.mode.map((item, i) => {
                        return {name: item.modelName, value: item.modelId}
                    })
                }
            
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/deviceModelMultipl.vue